
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/uxcg",
      function () {
        return require("private-next-pages/uxcg/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/uxcg"])
      });
    }
  